// import './DrawerAppBar.css';
import  { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import useScrollTrigger from '@mui/material/useScrollTrigger';
import Slide from '@mui/material/Slide';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { disable } from 'workbox-navigation-preload';

import { Link, useNavigate, useParams } from 'react-router';
import { alignSelf, display, justifyContent, positions, textAlign, width } from '@mui/system';

// context
import {useAuthData} from '../../../Context/AuthContext';

const drawerWidth = 240;
const navItems    = ['Home', 'About', 'Contact', 'newItem'];

function HideOnScroll(props) {

  const trigger              = useScrollTrigger();
  const [width, setWidth]    = useState(window.innerWidth);

    useEffect( () => {

        const handleResize = () => setWidth(window.innerWidth);

        window.addEventListener("resize", handleResize);
        
        return () => window.removeEventListener("resize", handleResize);

    }, [] );
  
  return (
    <Slide appear={false} direction="down" in={width >= 1024 ? true : !trigger}>
      {props.children}
    </Slide>
  );
}

// props
  function DrawerAppBar({window,onUserLogin}) {

    const authData = useAuthData();

    // const { window } = props;
    const [mobileOpen, setMobileOpen] = useState(false);

    const navigate = useNavigate();

    const handleDrawerToggle = () => {
      setMobileOpen((prevState) => !prevState);
    };

    const onListItemClick = (oEvent) => {
      
    let sNavItem = oEvent.target.getHTML();

     switch(sNavItem) {

      case 'Home':
        navigate('/');
      break;

      case 'About':
        navigate('/about');
      break;

      case 'Contact':
        navigate('/contact');
      break;

      case 'newItem':
        if(authData.isAuthenticated) {
          navigate('/newItem');
        } 

        if(!authData || !authData.isAuthenticated) {
          //display login windows
          navigate('/newItem');
        }
       
      break;

      default: //

     }
    };

    const drawer = (
      <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
        <Typography variant="h6" sx={{ my: 2 }}>
          Beetko
        </Typography>
        <Divider />
        <List>
          {navItems.map((item) => (
            <ListItem key={item} disablePadding>
              <ListItemButton onClick={onListItemClick} sx={{ textAlign: 'center' }}>
                <ListItemText primary={item} sx={{ fontWeight:'bold', fontSize:30 }}/>
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>
    );

    const container = window !== undefined ? () => window().document.body : undefined;


    return (
      
      <Box>
        <CssBaseline />
        <HideOnScroll>
          <AppBar component="nav"
                          sx={{ bgcolor: '#ffffff',
                          left:'auto',
                          right:'auto',
                          boxShadow: 'none',
                          zindex:0 ,
                          width:{lg:1024, xl:1024},
                          maxWidth:{lg:1024,maxWidth:1024},
                          mx:{lg:'auto', xl:'auto'}
                            
                            // "@media (min-width:1024px) and (max-width:1280px)" : {
                            //     width: "lg",
                            //     maxWidth:'lg',
                            //     mx: 'auto'
                            // },
                            // "@media screen and (min-width:1280px)" : {
                            //     mx: 'auto',
                            //     width: "lg",
                            //     maxWidth:'lg'
                            // }                        
                            
                            }}>
                                {/* //space-between */}
          <Toolbar sx={{display:'flex', justifyContent:'start'}}> 

            <Box sx={{display:'flex', justifyContent:'space-around'}}>
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: -1, color: 'Gray', display: {  xs: 'block', sm: 'block', md: 'none' } }} //,
                onClick={handleDrawerToggle}>
                  {/* <MenuIcon  sx={{ width: 30, height: 30, borderRadius: 50 }}/> */}
                  <FontAwesomeIcon size="1x" icon={faBars} />
              </IconButton>
            </Box>
            
            <Box sx={{
                  display: {
                      xs: 'none',
                      sm: 'none', 
                      md:' block' 
                      }
                  }}>

              { navItems.map((item) => (
                <Button onClick={onListItemClick} key={item} sx={{ color: 'gray'  }}>
                  {item}
                </Button>
              ))}

            </Box>


            <Button
                onClick={ (oEvent) => onUserLogin('fltr',oEvent) } 
                variant='outlined'
                sx={{
                  alignSelf:'center',
                  marginRight:'1rem',
                  marginLeft:'1rem'
                }}>
                    {authData.isAuthenticated ? authData['userData'].fullname : 'login'}
            </Button>
            
            <Box sx={{width:'9rem'}}>


                {/* <Button  
                      variant='outlined'>
                    Call us
                </Button> */}

                <Box 
                    component="img"
                    alt="The house from the offer."
                    src='https://templates-sources.s3.eu-central-1.amazonaws.com/template_001/logo2.png'
                    sx={{ alignSelf:'center',  width: 45,height: 45,position: 'absolute', left:10,top:5, marginTop:0.3 }}>
                </Box>
            </Box>
              

              {/* <img
                width={35}
                sx={{ mr: 'auto' }}
                src='https://bucket001-realestate.s3.eu-central-1.amazonaws.com/Logo/logo_home_dark_v05.png'
                id="logo" 
                alt="beetko"/> */}
          </Toolbar>
          </AppBar>
        </HideOnScroll>

        <nav>
          <Drawer
            anchor='right'
            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
              display: { xs: 'block',
                  sm: 'block', 
                  md:' none', 
                  lg: 'none', 
                  xl: 'none'
              },
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
            }}
          >
            {drawer}
          </Drawer>
        </nav>
        </Box>
    );
  }


export default DrawerAppBar;